<ng-container *ngIf="userProfile">
    <ng-container *ngIf="isEditing && editingAllowed">
        <div class="form-container">
            <ng-container *ngIf="displayLegalFirstNames">
                <div class="form-row form-row-double">
                    <mat-form-field class="input-half mobile-full">
                        <input
                            #leglFirstNamesControl="ngModel"
                            (change)="onChange()"
                            (keyup)="onChange()"
                            [(ngModel)]="userProfile.legalFirstNames"
                            [disabled]="!isEditing || disabled"
                            placeholder="Legal first name(s)"
                            i18n-placeholder="@@deals.user-profile.placeholder.legal-first-names"
                            matInput
                            name="legalFirstNames"
                            required
                            type="text"
                        />
                        <mat-error i18n="@@deals.user-profile.validation.first-name">Invalid answer</mat-error>
                    </mat-form-field>
                </div>
            </ng-container>

            <div class="form-row form-row-double" *ngIf="displayName">
                <mat-form-field class="input-half">
                    <input
                        matInput
                        type="text"
                        id="name"
                        autocomplete="given-name"
                        name="fname"
                        [(ngModel)]="userProfile.firstName"
                        placeholder="First name"
                        i18n-placeholder="@@deals.user-profile.placeholder.first-name"
                        [disabled]="!isEditing || disabled"
                        required
                        minlength="2"
                        maxlength="50"
                        (change)="onChange()"
                    />
                    <mat-error i18n="@@deals.user-profile.validation.first-name">Invalid answer</mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="language === 'nl'" class="input-quarter">
                    <input
                        matInput
                        type="text"
                        autocomplete="additional-name"
                        name="mname"
                        [(ngModel)]="userProfile.lastNamePrefix"
                        placeholder="Last name prefix"
                        i18n-placeholder="@@deals.user-profile.placeholder.last-name-prefix"
                        maxlength="30"
                        [disabled]="!isEditing || disabled"
                        (change)="onChange()"
                    />
                    <mat-error i18n="@@deals.user-profile.validation.last-name-prefix">Invalid answer</mat-error>
                </mat-form-field>
                <mat-form-field class="input-half">
                    <input
                        matInput
                        type="text"
                        autocomplete="family-name"
                        name="lname"
                        [(ngModel)]="userProfile.lastName"
                        placeholder="Last name"
                        i18n-placeholder="@@deals.user-profile.placeholder.last-name"
                        [disabled]="!isEditing || disabled"
                        required
                        minlength="2"
                        maxlength="80"
                        (change)="onChange()"
                    />
                    <mat-error i18n="@@deals.user-profile.validation.last-name">Invalid answer</mat-error>
                </mat-form-field>
            </div>

            <ng-container *ngIf="displayPhonenumber">
                <div class="form-row form-row-double">
                    <mat-form-field class="input-half mobile-full">
                        <input
                            matInput
                            #phoneNumberControl="ngModel"
                            type="tel"
                            [pattern]="telephoneNumberPattern"
                            autocomplete="tel"
                            name="mobile"
                            [(ngModel)]="userProfile.telephoneNumber"
                            placeholder="Telephone number"
                            i18n-placeholder="@@deals.user-profile.placeholder.phone-number"
                            [disabled]="!isEditing || disabled"
                            required
                            (change)="onChange()"
                            (keyup)="onChange()"
                        />
                        <mat-error i18n="@@deals.user-profile.validation.phone-number"
                            >Invalid telephone number</mat-error
                        >
                    </mat-form-field>
                </div>
            </ng-container>

            <ng-container *ngIf="displayAddress && userProfile.address">
                <mg-deal-address [(ngModel)]="userProfile.address" (change)="onChange()" [disabled]="disabled">
                </mg-deal-address>
            </ng-container>
        </div>
    </ng-container>

    <div
        class="info-summary"
        *ngIf="
            (!editingAllowed || !isEditing) &&
            ((displayName && hasName) ||
                (displayAddress && hasAddress) ||
                (displayPhonenumber && userProfile.telephoneNumber))
        "
    >
        <div class="info-summary__row" *ngIf="displayName && hasName">
            <span class="info-summary__label" i18n="@@deals.user-profile.display-label.name">Name</span>
            {{ userProfile.firstName }} {{ userProfile.lastNamePrefix }} {{ userProfile.lastName }}
        </div>
        <div class="info-summary__row" *ngIf="displayPhonenumber && userProfile.telephoneNumber">
            <span class="info-summary__label" i18n="@@deals.user-profile.display-label.phone-number"
                >Telephone number</span
            >
            {{ userProfile.telephoneNumber }}
        </div>
        <div class="info-summary__row" *ngIf="displayAddress && hasAddress">
            <span class="info-summary__label" i18n="@@deals.user-profile.display-label.address">Address</span>
            {{ userProfile.address.street }} {{ userProfile.address.houseNumber }}
            {{ userProfile.address.houseNumberSuffix }}
            <br />
            {{ userProfile.address.zipcode }} {{ userProfile.address.city }}
        </div>
        <button mat-button (click)="isEditing = true" *ngIf="editingAllowed && !isEditing">
            <mat-icon>edit</mat-icon>
            <ng-container i18n="@@deals.user-profile.edit-details">Edit my details</ng-container>
        </button>
    </div>
</ng-container>
